document.addEventListener('DOMContentLoaded', function() {
    const toggleButtons = document.querySelectorAll('.js-open-searchBox');
    const searchBox = document.querySelector('.searchBox');

    toggleButtons.forEach(button => {
      button.addEventListener('click', function() {
          if (searchBox.classList.contains('js-show')) {
              searchBox.classList.remove('js-show');
          } else {
              searchBox.classList.add('js-show');
          }
      });
    });
});